/**
 * Keep native date/time pickers aligned with the application locale.
 * Moodle datetime-local fields rely on the browser picker; this sets BCP 47
 * lang on inputs and <html> so Chrome/Edge can localize the popup UI.
 */
import { getUiLang } from './select2-language';

function getAppLocaleTag() {
    var raw = (typeof window.locale === 'string' && window.locale)
        ? window.locale
        : (window.localStorage && localStorage.getItem('locale')) || 'de_DE';
    if (raw.indexOf('_') !== -1) {
        return raw.replace('_', '-');
    }
    return getUiLang() === 'de' ? 'de-DE' : 'en-US';
}

export function syncNativeDateLocale(root) {
    var localeTag = getAppLocaleTag();
    if (document.documentElement) {
        document.documentElement.setAttribute('lang', localeTag);
    }

    var $root = root ? $(root) : $(document);
    $root.find('input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"], input[type="week"]')
        .attr('lang', localeTag);
}

if (typeof window !== 'undefined') {
    window.syncNativeDateLocale = syncNativeDateLocale;
}
